import { render, staticRenderFns } from "./tenantDayTrade.vue?vue&type=template&id=63efe841&scoped=true&"
import script from "./tenantDayTrade.vue?vue&type=script&lang=js&"
export * from "./tenantDayTrade.vue?vue&type=script&lang=js&"
import style0 from "./tenantDayTrade.vue?vue&type=style&index=0&id=63efe841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63efe841",
  null
  
)

export default component.exports